var DocumentAccordion = /** @class */ (function () {
    function DocumentAccordion() {
        this.documentPage = document.querySelector('.documents-page');
        this.documentItems = Array.from(this.documentPage.querySelectorAll('.document-item'));
        this.addEventListeners();
    }
    DocumentAccordion.prototype.addEventListeners = function () {
        var _this = this;
        this.documentItems.forEach(function (documentItem) {
            var documentItemHeader = documentItem.querySelector('.document-item-header');
            documentItemHeader.addEventListener('click', _this.toggleDocumentItem.bind(_this));
        });
    };
    DocumentAccordion.prototype.toggleDocumentItem = function (event) {
        var documentItemHeader = event.currentTarget;
        var documentItemContainer = documentItemHeader.parentElement;
        var documentContentIsOpen = documentItemContainer.classList.contains('active');
        if (documentContentIsOpen) {
            documentItemContainer.classList.remove('active');
        }
        else {
            documentItemContainer.classList.add('active');
        }
    };
    return DocumentAccordion;
}());
export default DocumentAccordion;
